<!--
  Copyright (C) 2022 - Jeci SARL - https://jeci.fr

  This program is free software: you can redistribute and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see https://www.gnu.org/licenses/agpl-3.0.html.
-->

<template>
  <div class="flex flex-column gap-3">
    <div class="form-field">
      <label class="form-label" for="lex-id">{{
        $t("lexiconForm.id.label")
      }}</label>
      <PrimeInputText
        id="lex-id"
        v-model="editableLexicon.id"
        :disabled="isEditMode"
        class="w-full"
      />
      <small class="form-help">{{ $t("lexiconForm.id.help") }}</small>
    </div>

    <div class="form-field">
      <label class="form-label" for="lex-label">{{
        $t("lexiconForm.label.label")
      }}</label>
      <PrimeInputText
        id="lex-label"
        v-model="editableLexicon.label"
        class="w-full"
      />
      <small class="form-help">{{ $t("lexiconForm.label.help") }}</small>
    </div>

    <div class="form-field">
      <label class="form-label" for="lex-values">{{
        $t("lexiconForm.values.label")
      }}</label>
      <PrimeTextarea
        id="lex-values"
        v-model="valuesAsString"
        rows="10"
        class="w-full"
      />
      <small class="form-help">{{ $t("lexiconForm.values.help") }}</small>
    </div>
  </div>
</template>

<script>
import InputText from "primevue/inputtext";
import Textarea from "primevue/textarea";

export default {
  name: "LexiconForm",
  components: {
    PrimeInputText: InputText,
    PrimeTextarea: Textarea,
  },
  props: {
    lexicon: { type: Object, default: null },
    existingLexicons: { type: Array, default: () => [] },
  },
  emits: ["save"],
  data() {
    return {
      editableLexicon: { id: "", label: "", values: [] },
      valuesAsString: "",
      isEditMode: false,
    };
  },
  watch: {
    lexicon: {
      handler(newVal) {
        if (newVal && newVal.id) {
          this.isEditMode = true;
          this.editableLexicon = JSON.parse(JSON.stringify(newVal));
        } else {
          this.isEditMode = false;
          this.editableLexicon = newVal
            ? JSON.parse(JSON.stringify(newVal))
            : { id: "", label: "", values: [] };
        }
        if (!this.editableLexicon.values) {
          this.editableLexicon.values = [];
        }
        this.valuesAsString = this.editableLexicon.values.join("\n");
      },
      immediate: true,
    },
  },
  methods: {
    submit() {
      if (!this.editableLexicon.id || !this.editableLexicon.label) {
        return;
      }
      if (
        !this.isEditMode &&
        this.existingLexicons.some((l) => l.id === this.editableLexicon.id)
      ) {
        return;
      }
      this.editableLexicon.values = this.valuesAsString
        ? this.valuesAsString
            .split("\n")
            .map((v) => v.trim())
            .filter((v) => v)
        : [];
      this.$emit("save", { ...this.editableLexicon });
    },
  },
};
</script>

<style scoped>
.form-field {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.form-label {
  font-size: 0.75rem;
  color: var(--p-text-muted-color, #6b7280);
  font-weight: 600;
}

.form-help {
  font-size: 0.75rem;
  color: var(--p-text-muted-color, #6b7280);
  font-style: italic;
}
</style>
